import { Dispatch } from 'redux';
import ActionType from '../actionTypes/buyDialogActionTypes';
import ApiEndpoints from '../ApiEndpoints';
import { handleRequest } from './helpers';
import { CartItemsSchema } from '../../schemas/cartItems';
import * as actions from './index';
import SnackBarType from '../../objects/app/snackbar';
import i18next from 'i18next';

export const loadCart = (
    customerId: number | null,
    guestId: number | null
) => async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
    const url = ApiEndpoints.GET_CART_ITEMS(customerId, guestId);
    const actionTypes = ActionType.loadCart;

    return handleRequest(url, dispatch, actionTypes, (data: any) => {
        return CartItemsSchema.parse(data);
    });
};

export const deleteCartItem = (
    customerId: number | null,
    guestId: number | null,
    idDesignJson: number,
    idProduct: number,
    idProductAttribute: number
) => async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
    const url = ApiEndpoints.DELETE_CART_ITEMS(customerId, guestId);
    const actionTypes = ActionType.loadCart;

    return handleRequest(
        url,
        dispatch,
        actionTypes,
        null,
        'get',
        { idDesignJson, idProduct, idProductAttribute },
        {},
        {},
        null,
        () => {
            dispatch(
                actions.addSnackbar(
                    i18next.t('Item removed from cart successfully.'),
                    SnackBarType.SUCCESS,
                    false
                )
            );
        }
    );
};
